import Cookies from 'js-cookie';
import { bumexFeaturesKeys } from '../constants/bumexFeatures';

const siteId = process.env.REACT_APP_BUILD_SITE;
const newPublisherAccess = ['DVPE', 'UBPE', 'ZPAR', '24MX', 'IWBR', 'WIBR', 'PLEC', 'CAPA', 'CMBR', 'VAMX'].includes(
  siteId
);

/**
 * Get link to publish page based on user type and site features
 * @returns {string} link to publish page
 */
const getLinkToPublish = (userIsParticular = false, bumexFeatures = new Map()) => {
  const showOldRepproCookie = Cookies.get('showOldReppro');

  // Caso 1 : Usuarios particulares de portales de CMBR
  if (siteId.includes('CMBR') && userIsParticular) {
    return '/anuncie-seu-imovel';
  }
  // Caso 2: Usuarios particulares del resto de los portales
  if (userIsParticular) {
    return '/panel/publicador/principales/operacionypropiedad';
  }
  // Caso 3: Usuarios profesionales de portales habilitados para publicar sólo clasificados en el Publicador Nuevo
  if (
    bumexFeatures.get(bumexFeaturesKeys.NEW_REALESTATE_PRO_PUBLISHER_ENABLE) &&
    bumexFeatures.get(bumexFeaturesKeys.NOW_PUBLISHER_FLOW_DEVELOPMENTS_DISABLED) &&
    !showOldRepproCookie
  ) {
    return 'panel/publicador-profesionales/main';
  }
  // Caso 4: Esto es solo para BR, en caso de tener la cookie, redirige al publicador viejo.
  if (
    bumexFeatures.get(bumexFeaturesKeys.NEW_REALESTATE_PRO_PUBLISHER_ENABLE) &&
    bumexFeatures.get(bumexFeaturesKeys.NOW_PUBLISHER_FLOW_DEVELOPMENTS_DISABLED) &&
    showOldRepproCookie
  ) {
    return '/publicarPasoDatosPrincipales.bum';
  }
  // Caso 5: Usuarios profesionales de portales habilitados para publicar desarrollos y clasificados en el Publicador Nuevo
  if (bumexFeatures.get(bumexFeaturesKeys.NEW_REALESTATE_PRO_PUBLISHER_ENABLE)) {
    return '/panel/publicador-profesionales';
  }
  // Caso 5: Usuarios profesionales de portales habilitados para publicar sólo en el Publicador Viejo
  return '/publicar.bum';
};

/**
 * Get link to edit page based on user type, site features and posting type
 * @returns {string} link to edit the posting
 */
const getLinkToEdit = (userIsParticular = false, bumexFeatures = new Map(), postingId, isDevelopment = false) => {
  // Caso 1 : Usuarios particulares
  if (userIsParticular && newPublisherAccess) {
    return `/panel/publicador/principales/operacionypropiedad?postingId=${postingId}`;
  }
  // Caso 2: Usuarios profesionales de portales habilitados para editar sólo clasificados en el Publicador Nuevo
  if (bumexFeatures.get(bumexFeaturesKeys.NEW_REALESTATE_PRO_PUBLISHER_ENABLE) && !isDevelopment) {
    return `/panel/publicador-profesionales/edition?postingId=${postingId}`;
  }
  // Caso 3: Usuarios profesionales de portales habilitados para editar desarrollos y clasificados en el Publicador Viejo
  return `/publicarPasoDatosPrincipales.bum?idaviso=${postingId}&checkContentEnhancerUrl=true`;
};

export { getLinkToEdit, getLinkToPublish };
